<template>
  <div class="appBg">
    <!-- <div class="t-container"> -->
    <b-row>
      <b-col class="bp-info">
        <!-- <img src="./../assets/logo3.svg" width="300" alt="" /> -->
        <!-- <img src="./../assets/Icon_white.png" alt="" /> -->
        <!-- <h1>BuzzPoint</h1> -->
        <p class="home-title text-right">
          {{ $t("homeTitle") }}
        </p>
      </b-col>
    </b-row>
    <b-row>
      <div class="cover-arrow">
        <div
          class="cover-arrow-wrapper cover-arrow-wrapper-animated"
          v-scroll-to="{ el: '#element' }"
        >
          <!-- v-scroll-to="{ el: '#element', offset: -60 }" -->
          <div class="cover-arrow-mobile">
            <svg
              class="cover-arrow-svg"
              style="fill:#ff2929;"
              x="0px"
              y="0px"
              width="38.417px"
              height="18.592px"
              viewBox="0 0 38.417 18.592"
            >
              <g>
                <path
                  d="M19.208,18.592c-0.241,0-0.483-0.087-0.673-0.261L0.327,1.74c-0.408-0.372-0.438-1.004-0.066-1.413c0.372-0.409,1.004-0.439,1.413-0.066L19.208,16.24L36.743,0.261c0.411-0.372,1.042-0.342,1.413,0.066c0.372,0.408,0.343,1.041-0.065,1.413L19.881,18.332C19.691,18.505,19.449,18.592,19.208,18.592z"
                ></path>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </b-row>
  </div>
  <!-- <v-parallax src="./../assets/crosswalk.jpg" height="800"></v-parallax> -->
</template>

<script>
export default {
  methods: {
    scrollDown() {
      console.log("arrow clicked");
    }
  }
};
</script>

<style>
.appBg::before {
  content: " ";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.6;
  background: url("./../assets/crosswalk.jpg");
  background-repeat: no-repeat;
  background-position: 50% 0;
  -ms-background-size: cover;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  background-size: cover;
  /* background-position: left top; */

  background-attachment: fixed;
}

.appBg {
  /* background: url("./../assets/crosswalk.jpg");
  background-color: rgba(255, 255, 255, 0.1);
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover; */
  height: 100vh;
  color: white;
  position: relative;
  background: #000;
  overflow: hidden;
}

.bp-info {
  position: absolute;
  /* width: 50vw !important; */
  max-width: 90% !important;
  margin: auto;
  /* bottom: 50%; */
  /* left: 40vw; */
  top: 30vh !important;
}

.home-title {
  font-size: 1.2em;
  font-weight: 500;
  text-transform: uppercase;
  text-align: end;
  word-wrap: inherit;
}

@media screen and (min-width: 668px) {
  .bp-info {
    position: relative;
    max-width: 50vw !important;
    /* height: 200px; */
    /* bottom: 50%; */
    left: 15vw;
    /* margin: auto; */
    top: 20vh;
  }

  .home-title {
    font-size: 2.5em;
    font-weight: 500;
    text-transform: uppercase;
    word-wrap: break-word;
  }
}

.cover-arrow {
  position: absolute;
  z-index: 1;
  bottom: 10%;
  right: 0;
  left: 0;
  text-align: center;
}

.cover-arrow-wrapper {
  display: inline-block;
  -webkit-transition: all ease-in-out 0.2s;
  -moz-transition: all ease-in-out 0.2s;
  -o-transition: all ease-in-out 0.2s;
  transition: all ease-in-out 0.2s;
  cursor: pointer;
}

.cover-arrow-wrapper-animated {
  animation: arrow-bottom 1.7s infinite ease;
}

.cover-arrow_mobile {
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -webkit-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

@-webkit-keyframes arrow-bottom {
  0% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
  }

  50% {
    -moz-transform: translateY(-7px);
    -ms-transform: translateY(-7px);
    -webkit-transform: translateY(-7px);
    -o-transform: translateY(-7px);
    transform: translateY(-7px);
  }

  55% {
    -moz-transform: translateY(-7px);
    -ms-transform: translateY(-7px);
    -webkit-transform: translateY(-7px);
    -o-transform: translateY(-7px);
    transform: translateY(-7px);
  }

  100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
  }
}

@keyframes arrow-bottom {
  0% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
  }

  50% {
    -moz-transform: translateY(-7px);
    -ms-transform: translateY(-7px);
    -webkit-transform: translateY(-7px);
    -o-transform: translateY(-7px);
    transform: translateY(-7px);
  }

  55% {
    -moz-transform: translateY(-7px);
    -ms-transform: translateY(-7px);
    -webkit-transform: translateY(-7px);
    -o-transform: translateY(-7px);
    transform: translateY(-7px);
  }

  100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
  }
}
</style>
